import React from 'react';

import styles from './wave.module.css'

export default function Index() {
  const len = Array(11).fill('');
  return (
    <div className={styles.wrapper}>
      {
        len.map((_, i) => <span className={styles.item} key={i} style={{ '--delay': `${(len.length - i) / 10}s` } as React.CSSProperties}></span>)
      }
    </div>
  )
}
